// Modules
import { AntdModule } from './antd.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// Components
import { AvatarComponent } from './components/avatar/avatar.component';
import { ButtonComponent } from './components/button/button.component';
import { FormInputFileComponent } from './components/form-items/form-input-file/form-input-file.component';
import { FormInputPasswordComponent } from './components/form-items/form-input-password/form-input-password.component';
import { FormInputSelectComponent } from './components/form-items/form-input-select/form-input-select.component';
import { FormInputTextComponent } from './components/form-items/form-input-text/form-input-text.component';
import { FuzzyFilterPipe } from './pipes/fuzzy-filter.pipe';
import { IconComponent } from './components/icon/icon.component';
import { InputSelectComponent } from './components/input-select/input-select.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { ModalCancelButtonComponent } from './components/modal/modal.cancel-button.component';
import { ModalComponent } from './components/modal/modal.component';
import { ModalContentComponent } from './components/modal/modal.content.component';
import { ModalDeleteButtonComponent } from './components/modal/modal.delete-button.component';
import { ModalFooterComponent } from './components/modal/modal.footer.component';
import { ModalTitleComponent } from './components/modal/modal.title.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { UserAvatarComponent } from './components/avatar/user-avatar.component';

const components = [
  AvatarComponent,
  ButtonComponent,
  FormInputSelectComponent,
  FormInputTextComponent,
  FormInputPasswordComponent,
  IconComponent,
  InputSelectComponent,
  InputTextComponent,
  FormInputFileComponent,
  ModalCancelButtonComponent,
  ModalDeleteButtonComponent,
  ModalComponent,
  ModalContentComponent,
  ModalFooterComponent,
  ModalTitleComponent,
  PageTitleComponent,
  UserAvatarComponent,
];
const pipes = [FuzzyFilterPipe];

@NgModule({
  declarations: [...components, ...pipes],
  imports: [AntdModule, FormsModule, ReactiveFormsModule, TranslateModule, CommonModule, RouterModule],
  exports: [AntdModule, FormsModule, ReactiveFormsModule, ...components, ...pipes],
})
export class ComponentLibraryModule {}
